var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedbackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4481 14.8463V22.2309C26.4481 23.7632 25.1365 25.0001 23.5118 25.0001H7.85137C6.2266 25.0001 4.91504 23.7632 4.91504 22.2309V11.154C4.91504 9.62169 6.2266 8.38477 7.85137 8.38477H14.7028",
    stroke: "#3A77BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13H4.9151V20.3846H2.95755C1.8809 20.3846 1 19.5538 1 18.5385V13Z",
    stroke: "#3A77BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.76953V18.5387",
    stroke: "#3A77BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3633 2.84615V8.3846C30.3633 9.39998 29.4824 10.2308 28.4057 10.2308H22.5331L20.5755 12.0769L18.618 10.2308H16.6604C15.5838 10.2308 14.7029 9.39998 14.7029 8.3846V2.84615C14.7029 1.83077 15.5838 1 16.6604 1H28.4057C29.4824 1 30.3633 1.83077 30.3633 2.84615Z",
    stroke: "#B4D334",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80908 16.6922C10.8857 15.6769 12.6377 15.6676 13.7242 16.6922",
    stroke: "#3A77BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8054 16.6922C18.8821 15.6769 20.6341 15.6676 21.7205 16.6922",
    stroke: "#3A77BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7454 21.3076H18.618",
    stroke: "#3A77BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIcon);
export default __webpack_public_path__ + "static/media/FeedbackIcon.c4a33264bc92e66706766d3de92078cb.svg";
export { ForwardRef as ReactComponent };